module.exports = __webpack_public_path__ + "img/img_phone1_SFA.accb7fb9.png";